import { defaultTheme } from '@expo/ui/src/core/theme';
import { useChosenCharity } from '../../../../traits/context/chosenCharity';
import { MainButton, SecondaryButton } from '@expo/ui/src/buttons';
import { Input, RadioButton } from '@expo/ui/src/inputs';
import { Margin } from '@expo/ui/src/layout';
import { H3, P, ErrorText } from '@expo/ui/src/typography';
import { PlanMetadataDto, PlanMetadataDtoSaleTechniqueEnum } from '@expo/api-client';

type Props = {
  onSubmit: () => void;
  setSsid: (ssid: string) => void;
  ssidError: string | null;
  ssid: string;
  metadata: PlanMetadataDto;
  setMetadata: (metadata: PlanMetadataDto) => void;
  setManualEntry: (manual: boolean) => void;
};

export const RetrieveSparData = ({
  onSubmit,
  setSsid,
  ssid,
  ssidError,
  metadata,
  setMetadata,
  setManualEntry,
}: Props) => {
  const { chosenCharity } = useChosenCharity();

  return (
    <>
      <Margin $top="7xl" />
      <H3>Uppge personnummer</H3>
      <P color={defaultTheme.colors.darkerGrey}>Dina uppgifter hämtas automatiskt i nästa steg</P>
      <Margin $top="xl" />
      <Input
        charityStyles={chosenCharity}
        value={ssid}
        onChangeText={newSsid => setSsid(newSsid)}
        label="Personnummer"
        placeholder="YYYYMMDDXXXX"
        maxLength={13}
      />
      <Margin $top="l" />
      {ssidError && <ErrorText>{ssidError}</ErrorText>}
      <MainButton onClick={onSubmit} charityStyles={chosenCharity}>
        Gå vidare
      </MainButton>
      <Margin $top="m" />
      <SecondaryButton onClick={() => setManualEntry(true)} type="button">
        Ange manuellt
      </SecondaryButton>

      <Margin $top="xl" />
      <P>Typ av värvning</P>
      <Margin $top="s" />
      <RadioButton
        label="D2D"
        value={PlanMetadataDtoSaleTechniqueEnum.D2D}
        name="sale-technique"
        onChangeValue={saleTechnique =>
          setMetadata({ ...metadata, saleTechnique: saleTechnique as PlanMetadataDtoSaleTechniqueEnum })
        }
        checked={metadata.saleTechnique === PlanMetadataDtoSaleTechniqueEnum.D2D}
      />
      <Margin $top="s" />
      <RadioButton
        label="F2F"
        value={PlanMetadataDtoSaleTechniqueEnum.F2F}
        name="sale-technique"
        onChangeValue={saleTechnique =>
          setMetadata({ ...metadata, saleTechnique: saleTechnique as PlanMetadataDtoSaleTechniqueEnum })
        }
        checked={metadata.saleTechnique === PlanMetadataDtoSaleTechniqueEnum.F2F}
      />
    </>
  );
};
